import { polymorphicComponentWrapper } from "../../utilities";
import { Button } from "../button";
import { Center } from "../center";
import { Icon } from "../icon";
import { Text } from "../text";
import styles from "./stat-control.module.scss";
import type { CustomStatControlFactory, IProps } from "./stat-control.types";
import classNames from "classnames";

const StatControl = polymorphicComponentWrapper<CustomStatControlFactory, IProps>(
    "StatControl",
    ({ children, icon, active, ...otherProps }, ref) => {
        return (
            <Button
                className={classNames(styles["stat-control"], active && styles["active"])}
                ref={ref}
                variant="subtle"
                justify="flex-start"
                {...otherProps}
                leftSection={
                    <Center className={styles["icon-root"]}>
                        <Icon color={active ? "primary" : "white"} size="xs" icon={icon} />
                    </Center>
                }
            >
                <Text c={active ? "white" : "inherit"} variant="medium" size="md">
                    {children}
                </Text>
            </Button>
        );
    }
);

export { StatControl };
